module.exports = __webpack_public_path__ + "img/icon_toggle.b2c666d.png";